var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.159 6.71957C9.08531 6.78823 9.02621 6.87103 8.98522 6.96303C8.94423 7.05503 8.92218 7.15435 8.92041 7.25505C8.91863 7.35575 8.93716 7.45578 8.97488 7.54917C9.0126 7.64256 9.06874 7.72739 9.13996 7.79861C9.21118 7.86983 9.29601 7.92597 9.3894 7.96369C9.48279 8.00142 9.58282 8.01994 9.68352 8.01816C9.78423 8.01639 9.88354 7.99434 9.97554 7.95335C10.0675 7.91236 10.1503 7.85326 10.219 7.77957L13.469 4.52957L14 3.99957L13.47 3.46957L10.22 0.219572C10.0786 0.0828849 9.8892 0.00719892 9.69255 0.0088144C9.4959 0.0104299 9.30775 0.089218 9.16863 0.228209C9.02951 0.3672 8.95054 0.555273 8.94874 0.751921C8.94694 0.948568 9.02245 1.13806 9.159 1.27957L11.129 3.24957H0.75C0.551088 3.24957 0.360322 3.32859 0.21967 3.46924C0.0790177 3.60989 0 3.80066 0 3.99957C0 4.19848 0.0790177 4.38925 0.21967 4.5299C0.360322 4.67055 0.551088 4.74957 0.75 4.74957H11.129L9.159 6.71957Z",
    fill: "#2173FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlue);
export default __webpack_public_path__ + "static/media/arrow_left_blue.47ae92e7c66a25b4d07ab93b201667dc.svg";
export { ForwardRef as ReactComponent };